import { FC, useEffect, useState } from 'react';
import { Alert } from '@mui/material';

interface UploadManagerErrorsHandlerProps {
	errorMessage: string | null;
	resetErrors: () => void;
}

export const UploadManagerErrorsHandler: FC<UploadManagerErrorsHandlerProps> = ({ errorMessage, resetErrors }) => {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		setOpen(Boolean(errorMessage));
	}, [errorMessage]);

	const handleClose = () => {
		setOpen(false);
		resetErrors();
	};

	return (
		<>
			{open && (
				<Alert onClose={handleClose} sx={{ marginBottom: '10px' }} severity="error">
					{errorMessage}
				</Alert>
			)}
		</>
	);
};
